import React from 'react';
import FoodIcon from 'assets/img/content/myfood.jpg';

const AddIngredientList = ({
  commonList = [],
  brandedList = [],
  yourFoodList = [],
  handleSelectIngredient,
  isInitial
}) => {
  return (
    <div className="ingredient-list">
      {!isInitial &&
        commonList.length === 0 &&
        brandedList.length === 0 &&
        yourFoodList.length === 0 && (
          <section className="homepage-empty">
            <label>Item not found</label>
          </section>
        )}
      {commonList.length > 0 && (
        <>
          <FoodCategory
            label="Common Foods"
            foodList={commonList}
            onClick={handleSelectIngredient}
          />
          <br />
        </>
      )}
      {brandedList.length > 0 && (
        <>
          <FoodCategory
            label="Branded Foods"
            foodList={brandedList}
            onClick={handleSelectIngredient}
          />
          <br />
        </>
      )}
      {yourFoodList.length > 0 && (
        <FoodCategory
          label="Your Foods"
          foodList={yourFoodList}
          onClick={handleSelectIngredient}
        />
      )}
    </div>
  );
};

const FoodCategory = ({ label, foodList, onClick }) => {
  return (
    <ul>
      <h2>
        <span>{label}</span>
      </h2>
      {foodList.map((food, ind) => (
        <FoodItem key={ind} food={food} onClick={onClick} />
      ))}
    </ul>
  );
};

const FoodItem = ({ food, onClick }) => {
  const imgSrc = food.photo ? food.photo.thumb : FoodIcon;

  return (
    <li
      onClick={() => {
        food.isNew = true;
        onClick({
          ...food,
          original_weight: food.weight_grams,
          original_calories: food.calories,
          original_measure: food.measurement_unit,
          original_quantity: food.quantity_size
        });
      }}
    >
      <img src={imgSrc} alt="food" />
      <p>{food.name}</p>
    </li>
  );
};

export default AddIngredientList;
